import {Card, DataStatus} from 'platform/components';
import {VStack} from 'platform/foundation';

import {useGetManufacturerQuery} from '@dms/api/core';
import {MappedBasketItem} from '@dms/shared';

import {RequiredTestIdProps} from 'shared/web';

import {PlainMaterialBasketItem} from '../types/PlainMaterialBasketItem';
import {AfterSalesPlainMaterialBasketItemTitleWithActions} from './AfterSalesPlainMaterialBasketItemTitleWithActions';

interface AfterSalesPlainMaterialBasketItemProps<T extends PlainMaterialBasketItem>
  extends RequiredTestIdProps {
  item: MappedBasketItem<T>;
  onSelect: (itemId: string, isSelected: boolean) => void;
  onDelete: (itemsIds: string[]) => void;
}

export function AfterSalesPlainMaterialBasketItem<T extends PlainMaterialBasketItem>(
  props: AfterSalesPlainMaterialBasketItemProps<T>
) {
  const manufacturerQuery = useGetManufacturerQuery({manufacturerId: props.item.manufacturerId});

  return (
    <Card variant="inlineGrey" data-testid={props['data-testid']}>
      <DataStatus isLoading={manufacturerQuery.isLoading} minHeight={15}>
        <VStack spacing={1}>
          <AfterSalesPlainMaterialBasketItemTitleWithActions
            item={props.item}
            manufacturerName={manufacturerQuery.data?.name ?? ''}
            onSelect={props.onSelect}
            onDelete={props.onDelete}
            data-testid={props['data-testid']}
          />
        </VStack>
      </DataStatus>
    </Card>
  );
}
